/*
 * Dubai Looka — promotional email popup.
 *
 * Shows once per N days per browser. Every localStorage access is wrapped in
 * try/catch: Safari private mode throws on write, and an uncaught throw here
 * would abort the rest of this script. When storage is unavailable the popup
 * still works, it just cannot remember that it was dismissed.
 *
 * Focus handling reuses Dawn's trapFocus/removeTrapFocus from global.js.
 */
if (!customElements.get('promo-popup')) {
  customElements.define(
    'promo-popup',
    class PromoPopup extends HTMLElement {
      static STORAGE_KEY = 'dl-promo-seen';

      connectedCallback() {
        if (this.recentlySeen()) {
          this.remove();
          return;
        }

        this.querySelectorAll('[data-promo-close]').forEach((button) => {
          button.addEventListener('click', this.close.bind(this));
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        /* Submitting counts as engagement: do not ask this browser again. */
        const form = this.querySelector('form');
        if (form) form.addEventListener('submit', this.remember.bind(this));

        const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this.timer = setTimeout(this.open.bind(this), delay);
      }

      disconnectedCallback() {
        if (this.timer) clearTimeout(this.timer);
      }

      recentlySeen() {
        const days = parseInt(this.dataset.days, 10) || 14;
        let stamp = null;

        try {
          stamp = window.localStorage.getItem(PromoPopup.STORAGE_KEY);
        } catch (error) {
          return false;
        }

        if (!stamp) return false;
        return Date.now() - parseInt(stamp, 10) < days * 86400000;
      }

      remember() {
        try {
          window.localStorage.setItem(PromoPopup.STORAGE_KEY, String(Date.now()));
        } catch (error) {
          /* Storage unavailable; the popup simply reappears next visit. */
        }
      }

      open() {
        this.hidden = false;
        this.classList.add('is-open');
        this.previouslyFocused = document.activeElement;

        const field = this.querySelector('input[type="email"]');
        if (typeof trapFocus === 'function') {
          trapFocus(this, field || undefined);
        } else if (field) {
          field.focus();
        }
      }

      close() {
        this.remember();
        this.classList.remove('is-open');
        this.hidden = true;

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.previouslyFocused);
        }
      }
    }
  );
}
